import { observer, use$ } from '@legendapp/state/react';
import { Text } from '@mantine/core';
import NumberFlow from '@number-flow/react';
import Decimal from 'decimal.js';
import { useMemo } from 'react';
import { configurationState$ } from '../../state';
import { walletState$ } from '../../state/wallet.state';

export const MobileAccountBalance = observer(() => {
  const balance = use$(walletState$.balance);
  const currency = use$(configurationState$.currency);
  const decimalScale = use$(configurationState$.decimalScale);
  const formattedBalance = useMemo(() => {
    return new Decimal(balance)
      .toDecimalPlaces(decimalScale, Decimal.ROUND_DOWN)
      .toNumber();
  }, [balance, decimalScale]);
  return (
    <Text
      c="#FFFF49"
      data-balance={balance}
      data-test-id="mobile-account-balance"
      fw={600}
      size="md"
      style={{ flexGrow: 1, fontVariantNumeric: 'tabular-nums' }}
      ta="right"
    >
      <NumberFlow
        animated={true}
        format={{
          minimumFractionDigits: decimalScale,
          maximumFractionDigits: decimalScale,
          useGrouping: false,
        }}
        locales="en-u-nu-latn"
        respectMotionPreference={true}
        suffix={` ${currency}`}
        value={formattedBalance}
      />
    </Text>
  );
});
